var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('Views.Spaces.Dashboard.Main_Title')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }